export const pdfFontSize = {
  title: 14,
  subtitle: 12,
  text: 10,
}

export const pdfPadding = {
  xxSmall: 4,
  small: 8,
  medium: 16,
  large: 24,
  xLarge: 32,
}
